export default "__VITE_ASSET__rUZZqBOj__"